"use client";

import Image from "next/image";

import logo from "@/components/common/assets/logo.svg";
import logoSmall from "@/components/common/assets/logo-small.svg";
import { cn } from "@/lib/utils";

import { useTranslations } from "next-intl";

export type LogoSize = "xs" | "sm" | "md" | "lg";

export type LogoProps = {
  className?: string;
  scale?: number;
  size?: LogoSize;
  small?: boolean;
};

export function Logo({ className, scale, size, small }: LogoProps) {
  const t = useTranslations();

  if (size === "xs") {
    scale = 0.3;
  } else if (size === "sm") {
    scale = 0.6;
  } else if (size === "md") {
    scale = 1;
  } else if (size === "lg") {
    scale = 2;
  } else {
    scale = scale || 1;
  }

  const logoObj = small ? logoSmall : logo;

  return (
    <Image
      src={logoObj.src}
      width={logoObj.width * scale}
      height={logoObj.height * scale}
      alt={t("common.name")}
      className={cn("dark:brightness-0 dark:invert", className)}
    />
  );
}

Logo.displayName = "Logo";
